import { useEffect, useState } from "react";
import { CalendarClock } from "lucide-react";
import { toast } from "sonner";
import { api, apiError } from "@/lib/api";

const HowTo = () => (
  <details className="text-sm text-muted-foreground" data-testid="booking-link-howto">
    <summary className="cursor-pointer text-foreground">How to create your Google booking page</summary>
    <ol className="mt-2 list-decimal space-y-1 pl-5">
      <li>Open Google Calendar signed in as welcome@genesismembersclub.com (or the account you'll take calls from).</li>
      <li>Click Create → Appointment schedule. Name it "Screening call", set 20 minutes and your available hours, keep Google Meet on, then Save.</li>
      <li>Open the schedule, click Share, copy the booking page link (it starts with https://calendar.app.google/) and paste it here.</li>
    </ol>
  </details>
);

export const BookingLinkSettings = () => {
  const [url, setUrl] = useState("");
  const [saved, setSaved] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    api.get("/admin/settings").then(({ data }) => { setUrl(data.calendly_url); setSaved(data.calendly_url); }).catch(() => {});
  }, []);
  const save = async () => {
    setBusy(true);
    try { const { data } = await api.put("/admin/settings", { calendly_url: url }); setSaved(data.calendly_url); toast.success(data.calendly_url ? "Booking link saved" : "Booking link removed"); }
    catch (e) { toast.error(apiError(e)); } finally { setBusy(false); }
  };
  return (
    <section className="surface mt-8 space-y-3 p-5 sm:p-6" data-testid="booking-link-settings">
      <p className="flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-primary"><CalendarClock className="h-4 w-4" /> Screening call booking</p>
      <p className="text-sm text-muted-foreground">Paste your Google Calendar booking page link. <span className="text-foreground">Approve for screening</span> emails it to the applicant and shows a "Book your screening call" button on their status page. Google adds the Meet link and sends the confirmation and reminders.</p>
      <div className="flex flex-col gap-3 sm:flex-row">
        <input type="url" className="field flex-1" maxLength={300} placeholder="https://calendar.app.google/…" value={url}
          onChange={(e) => setUrl(e.target.value)} aria-label="Google Calendar booking page link" data-testid="booking-link-input" />
        <button type="button" className="btn-primary" disabled={busy || url.trim() === saved} onClick={save} data-testid="booking-link-save">Save link</button>
      </div>
      {!saved && <p className="text-xs text-muted-foreground" data-testid="booking-link-empty">No link yet. Add one before using Approve for screening.</p>}
      <HowTo />
    </section>
  );
};
